import {Injectable, inject, afterNextRender} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {filter} from 'rxjs/operators';
import {environment} from "../../../environments/environment";

// Declare the fbq function globally so TypeScript compiles cleanly
declare const fbq: Function;

@Injectable({
  providedIn: 'root'
})
export class MetaPixelService {
  private router = inject(Router);

  constructor() {
    // afterNextRender runs strictly on the client browser after the page loads
    afterNextRender(() => {
      if (environment.production) {
        this.initTracking();
      }
    });
  }

  // Called explicitly by AppComponent inside afterNextRender
  public initTracking(): void {
    if (typeof fbq !== 'function') {
      console.warn('⚠️ Meta Pixel fbq function is missing from window.');
      return;
    }

    // 1. Log the initial landing page view
    this.trackPageView(this.router.url);

    // 2. Subscribe to SPA router changes for subsequent page loads
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.trackPageView(event.urlAfterRedirects);
    });
  }

  private trackPageView(url: string): void {
    if (typeof fbq === 'function') {
      fbq('track', 'PageView');
    }
  }

  // Use this for tracking custom clicks or conversion actions
  public trackEvent(eventName: string, params: object = {}): void {
    if (typeof fbq === 'function') {
      if (environment.production) {
        console.log(`🎯 Meta Pixel Custom Event -> ${eventName}`, params);
        // Map custom keys to Meta standard events if matching names are used
        if (eventName === 'purchase_complete' || eventName === 'Purchase') {
          fbq('track', 'Purchase', params);
        } else if (eventName === 'lead' || eventName === 'Lead') {
          fbq('track', 'Lead', params);
        } else {
          fbq('trackCustom', eventName, params);
        }
      }
    }
  }
}
